import { getEnvironment } from '../utils/environment';
import { VERSION } from '../../version';
import styles from './EnvironmentLabel.module.scss';
import { useEffect, useState } from 'react';

export default function EnvironmentLabel() {
  function getTimestamp() {
    return new Date().toLocaleString('sv-SE');
  }

  const [start, setStart] = useState(getTimestamp());

  useEffect(() => {
    function onPageShow() {
      setStart(getTimestamp());
    }
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);
  const environment = getEnvironment();
  if (environment !== 'Test' && environment !== 'UAT') {
    return undefined;
  }
  return (
    <div className={styles['environment-label']}>
      <span className="sr-only">Körs i </span>
      <span className={styles.environment}>{environment}</span>
      <span className="sr-only"> med version </span>
      <span className={styles.version}>{VERSION}</span>
      <span className="sr-only"> och startades </span>
      <span className={styles.start}>{start}</span>
    </div>
  );
}
